// ── Browser-local Storage ────────────────────────────────────────────────────

export const Storage = {
  get(k) {
    try {
      const v = localStorage.getItem(k)
      return v ? JSON.parse(v) : null
    } catch {
      return null
    }
  },
  set(k, v) {
    try {
      localStorage.setItem(k, JSON.stringify(v))
    } catch {
      return null
    }
  },
}
